/**
 * util which returns the unique objects array given a uniqueKey
 * @param arrayOfObjects source array to filter duplicates
 * @param uniqueKey unique key in object
 * @returns unique array objects
 */
export const getUniqueObjectsArray = <T extends Record<string, unknown>>(
  arrayOfObjects: T[],
  uniqueKey: keyof T
) => {
  /**
   * to filter duplicates, construct a map from given array
   * with keys as uniqueKey of object and values as array items
   */
  return [
    ...arrayOfObjects
      .reduce((map, obj) => map.set(obj[uniqueKey], obj), new Map())
      .values(),
  ];
};
